import { Component ,Inject } from '@angular/core';
import {Router} from "@angular/router";
import {MatDialog, MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';

import { FormGroup, FormControl, FormBuilder,FormArray,Validators, NgForm } from '@angular/forms';

@Component({
    selector: 'addFolderDialog',
    templateUrl: 'addFolderDialog.component.html',
  })
  
  export class AddFolderDialogComponent {
    newFolder:string ='';
    model: any = {};
    constructor( 
    public dialogRef: MatDialogRef<AddFolderDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private router: Router) {}
   
    
  }


// WEBPACK FOOTER //
// ./src/app/memos/addFolderDialog.component.ts